module.exports = __webpack_public_path__ + "media/shuffle3.2cd1dc97.wav";